export default function hide(el, updateTabIndex = true, addAriaHidden = true) {
	if (!el) {
		return;
	}

	el.style.display = 'none';
	if (updateTabIndex) {
		el.setAttribute('tabindex', '-1');
	}
	if (addAriaHidden) {
		el.setAttribute('aria-hidden', true);
	}
}
